import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import OrdersManager from "@/components/admin/OrdersManager";

const TABS = ["Orders", "Payment Methods"];

export default function InvoiceAdmin() {
  const [tab, setTab] = useState("Orders");
  return (
    <div data-testid="admin-invoicing">
      <div className="flex gap-2 mb-6 border-b border-white/10">
        {TABS.map((t) => (
          <button key={t} onClick={() => setTab(t)} data-testid={`invadmin-tab-${t}`}
            className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px ${tab === t ? "border-cyan-400 text-cyan-300" : "border-transparent text-slate-400"}`}>{t}</button>
        ))}
      </div>
      {tab === "Orders" ? <OrdersManager /> : <Methods />}
    </div>
  );
}

function Methods() {
  const [methods, setMethods] = useState([]);
  useEffect(() => { api.get("/invoice/admin/payment-methods").then(({ data }) => setMethods(data)).catch(() => {}); }, []);
  const save = async () => { await api.put("/invoice/admin/payment-methods", { methods }); toast.success("Payment methods saved"); };
  const upd = (i, k, v) => setMethods((m) => m.map((x, idx) => idx === i ? { ...x, [k]: v } : x));
  return (
    <div className="space-y-3">
      {methods.map((m, i) => (
        <div key={m.key} className="rounded-2xl border border-white/10 p-4" data-testid={`invadmin-method-${m.key}`}>
          <div className="flex items-center gap-3 mb-2">
            <div className="font-semibold text-white">{m.label}</div>
            <label className="text-xs text-slate-400 flex items-center gap-1 ml-auto">
              <input type="checkbox" checked={!!m.enabled} onChange={(e) => upd(i, "enabled", e.target.checked)} /> enabled
            </label>
          </div>
          <input value={m.handle || ""} onChange={(e) => upd(i, "handle", e.target.value)} placeholder={`${m.label} handle / link (e.g. PayPal.me/you, @venmo, email)`}
            data-testid={`invadmin-handle-${m.key}`} className="w-full bg-black/40 border border-white/15 rounded-lg px-3 py-2 text-white text-sm mb-2" />
          <textarea value={m.instructions || ""} onChange={(e) => upd(i, "instructions", e.target.value)} rows={2}
            className="w-full bg-black/40 border border-white/15 rounded-lg px-3 py-2 text-slate-300 text-xs" />
        </div>
      ))}
      <button onClick={save} data-testid="invadmin-save-methods" className="px-5 py-2.5 rounded-xl bg-cyan-400 text-black font-semibold text-sm">Save payment methods</button>
    </div>
  );
}
